<template>
    <div class="statistics-content">
        <!-- 钻孔数量统计 -->
        <div id="drillBar" class="drill-statistics">

        </div>
        <!-- 钻探任务统计 -->
        <div class="pie-content" v-for="(task, index) in unitList" :key="index">
            <div class="title">{{ task.deptName }}</div>
            <div class="taskPie" :id="`pie-${index}`"></div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
    props: {
        unitList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            // 施工单位钻探任务
            // taskList: [
            //     {
            //         name: '云南施工单位',
            //         task: [
            //             {
            //                 name: '已完成',
            //                 value: 30
            //             },
            //             {
            //                 name: '进行中',
            //                 value: 80
            //             },
            //             {
            //                 name: '未开始',
            //                 value: 290
            //             },
            //         ]
            //     },
            //     {
            //         name: '四川施工单位',
            //         task: [
            //             {
            //                 name: '已完成',
            //                 value: 30
            //             },
            //             {
            //                 name: '进行中',
            //                 value: 80
            //             },
            //             {
            //                 name: '未开始',
            //                 value: 290
            //             },
            //         ]
            //     },
            // ]
        }
    },
    watch: {
        unitList() {
            this.$nextTick(() => {
                this.createDrillBar()
                for (let index = 0; index < this.unitList.length; index++) {
                    this.createTaskPie(index)
                }
            })
        }
    },
    mounted() {
        // console.log(this.uni);
        // this.createDrillBar()
        // for (let index = 0; index < this.unitList.length; index++) {
        //     this.createTaskPie(index)
        // }
    },
    methods: {
        // 创建钻孔统计柱状图
        createDrillBar() {
            var chartDom = document.getElementById('drillBar');
            var myChart = echarts.init(chartDom);
            var option = {
                title: {
                    text: '钻孔数量统计'
                },
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    bottom: "0%"
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    // type: 'category',
                    // data: data.map(item => {
                    //     return item.age
                    // }),
                    // interval: 8
                    type: 'value',
                    boundaryGap: [0, 1]
                },
                yAxis: {
                    type: 'category',
                    data: ['报告已提交', '施工已完成', '施工进行中', '未开始' ]
                },
                series: (() => {
                    var colorArray = ['#6BCCEA', '#68A4F1', '#95ADEE', '#C1ABE9', '#ECC4E0', '#78E3DE']
                    var colorIndex = 0
                    var array = []
                    this.unitList.filter(unit => {
                        let obj = {
                            name: unit.deptName,
                            type: 'bar',
                            data: [unit.zkDocCount, unit.zkDoneCount, unit.zkDoingCount, unit.zkNotStartedCount],
                            itemStyle: {
                                color: colorArray[colorIndex]
                            }
                        }
                        colorIndex += 1
                        array.push(obj)
                    })
                    return array
                })()
            };
            option && myChart.setOption(option);
        },
        // 饼状图
        createTaskPie(index) {
            var chartDom = document.getElementById(`pie-${index}`);
            var myChart = echarts.init(chartDom);
            const unit = this.unitList[index]
            var option = {
                title: {
                    text: unit.zkCount,
                    subtext: '总数量',
                    left: 'center',
                    top: '35%',
                    textStyle: {
                        fontSize: 18,
                        color: "#686B73",
                        align: "center",
                    },
                    subtextStyle: {
                        fontFamily: "微软雅黑",
                        fontSize: 12,
                        color: "#686B73",
                    }
                },
                tooltip: {
                    trigger: 'item',
                    show: true,
                    formatter: '{b}<br />占比：{d}%<br />数量：{c}'
                },
                legend: {
                    bottom: '0%',
                    left: 'center'
                },
                series: [
                    {
                        // name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                alignTo: 'edge',
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: (()=> {
                            return [
                                {
                                    name: '报告已提交',
                                    value: unit.zkDocCount,
                                    itemStyle: {
                                        color: unit.zkDocCount == 0 ? '#EEEEEE' : '#85B243'
                                    }
                                },
                                {
                                    name: '施工已完成',
                                    value: unit.zkDoneCount,
                                    itemStyle: {
                                        color: unit.zkDoneCount == 0 ? '#EEEEEE' : '#CEE55D'
                                    }
                                },
                                {
                                    name: '施工进行中',
                                    value: unit.zkDoingCount,
                                    itemStyle: {
                                        color: unit.zkDoingCount == 0 ? '#EEEEEE' : '#FBE59E'
                                    }
                                },
                                {
                                    name: '未开始',
                                    value: unit.zkNotStartedCount,
                                    itemStyle: {
                                        color: unit.zkNotStartedCount == 0 ? '#EEEEEE' : '#CCCCCC'
                                    }
                                },
                            ]
                        })(),
                    }
                ]
            };
            option && myChart.setOption(option);
        }
    },
}
</script>
<style scoped>
    .statistics-content {
        width: 100%;
        height: 100%;
        padding: 0;
        overflow: scroll;
    }
    .statistics-content::-webkit-scrollbar {
        width: 0;
    }
    .statistics-content .drill-statistics {
        width: calc(100% - 40px);
        height: 262px;
        border-radius: 6px;
        background: #fff;
        margin-bottom: 9px;
        padding: 20px;
    }
    .statistics-content .pie-content {
        width: calc(100% - 40px);
        height: 200px;
        border-radius: 6px;
        background: #fff;
        margin-bottom: 9px;
        padding: 20px;
    }
    .statistics-content .pie-content .title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 28px;
    }
    .statistics-content .pie-content .taskPie {
        width: 100%;
        height: 172px;
        background: #fff;
    }
</style>